<div class="flex flex-col gap-5 h-full">
  <pm-analysis-header />

  @let selectedVersion = this.analysisStateService.selectedVersion();
  @if (selectedVersion) {
    <mat-divider />
    <pm-analysis-version-metadata />

    @switch (selectedVersion.status) {
      @case (AnalysisVersionStatus.CREATED) {
        <pm-analysis-progress [status]="selectedVersion.status" />
      }
      @case (AnalysisVersionStatus.CALCULATING) {
        <pm-analysis-progress
          [status]="selectedVersion.status"
          [progress]="selectedVersion.progress"
        />
      }
      @case (AnalysisVersionStatus.FAILED) {
        <pm-error message="ANALYSIS.ERROR_VERSION_CALCULATION_FAILED" />
      }
      @case (AnalysisVersionStatus.FINISHED) {
        <div class="flex justify-between items-center">
          <pm-analysis-breadcrumbs />
          <div class="flex flex-row gap-4 items-center">
            <pm-grid-reset-filters [gridApi]="analysisTable.gridApi()" />
            <pm-grid-view-manager
              #viewManager
              [gridApi]="analysisTable.gridApi()"
              tableId="analysis"
            />
          </div>
        </div>
        <pm-analysis-table #analysisTable [viewManager]="viewManager" />
      }
    }
  }
</div>
